import type { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_LIGHT_BOX_MEDIA_TYPE = {
  Image: "image",
  Video: "video",
  Audio: "audio",
} as const;

export interface DSLightBoxItem {
  id: string | number;
  name: string;
  src: string;
  type: ObjectValues<typeof DS_LIGHT_BOX_MEDIA_TYPE>;
  alt?: string;
  description?: string;
  thumbnailSrc?: string;
}

export interface DSLightBoxProps {
  items?: DSLightBoxItem[];
  ariaLabel?: string;
}
